import * as angular from "angular";
import * as _ from "lodash";
import {DocumentSettings} from "../models/document-settings.model";
import {ReminderSettings} from "../models/reminder-settings.model";
import {VehicleStatusChangeReasonSettingsEntity} from "../models/vehicle-status-change-reason-settings.model";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class SettingsAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  getGeneralTasksError() {
    const message = {
      body: 'GENERAL_TASKS_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateGeneralTaskSuccess() {
    const message = {
      body: 'GENERAL_TASKS_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateGeneralTaskError() {
    const message = {
      body: 'GENERAL_TASKS_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //////////////////// DOCUMENTS ////////////////////
  getDocumentsError() {
    const message = {
      body: 'DOCUMENTS_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createDocumentSuccess() {
    const message = {
      body: 'DOCUMENT_CREATE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createDocumentError() {
    const message = {
      body: 'DOCUMENT_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateDocumentSuccess() {
    const message = {
      body: 'DOCUMENT_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateDocumentError() {
    const message = {
      body: 'DOCUMENT_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteDocumentSuccess(document: DocumentSettings) {
    const message = {
      body: 'X_DOCUMENT_DELETE_ONE_SUCCESS'
    };

    return this.bringozToastService.success(message, {name: document.name})
  }

  deleteDocumentError() {
    const message = {
      body: 'X_DOCUMENT_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //////////////////// REMINDERS ////////////////////

  getRemindersError() {
    const message = {
      body: 'REMINDERS_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createReminderSuccess() {
    const message = {
      body: 'REMINDER_CREATE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createReminderError() {
    const message = {
      body: 'REMINDER_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateReminderSuccess() {
    const message = {
      body: 'REMINDER_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateReminderError() {
    const message = {
      body: 'REMINDER_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteReminderSuccess(reminder: ReminderSettings) {
    const message = {
      body: 'X_REMINDER_DELETE_ONE_SUCCESS'
    };

    return this.bringozToastService.success(message, {name: reminder.name})
  }

  deleteReminderError() {
    const message = {
      body: 'X_REMINDER_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getAllVehicleStatusChangeReasonError() {
    const message = {
      body: 'VEHICLE_STATUS_CHANGE_REASON_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getAllPackageConfigurationsError() {
    const message = {
      body: 'PACKAGE_CONFIGURATIONS_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getOnePackageConfigurationError() {
    const message = {
      body: 'PACKAGE_CONFIGURATIONS_GET_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updatePackageConfigurationSuccess() {
    const message = {
      body: 'PACKAGE_CONFIGURATION_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updatePackageConfigurationError() {
    const message = {
      body: 'PACKAGE_CONFIGURATION_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createPackageConfigurationSuccess() {
    const message = {
      body: 'PACKAGE_CONFIGURATION_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createPackageConfigurationError() {
    const message = {
      body: 'PACKAGE_CONFIGURATION_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createVehicleStatusChangeReasonSuccess() {
    const message = {
      body: 'VEHICLE_STATUS_CHANGE_REASON_CREATE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createVehicleStatusChangeReasonError() {
    const message = {
      body: 'VEHICLE_STATUS_CHANGE_REASON_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateVehicleStatusChangeReasonSuccess() {
    const message = {
      body: 'VEHICLE_STATUS_CHANGE_REASON_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateVehicleStatusChangeReasonError() {
    const message = {
      body: 'VEHICLE_STATUS_CHANGE_REASON_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteVehicleStatusChangeReasonSuccess(vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) {
    const message = {
      body: 'X_VEHICLE_STATUS_CHANGE_REASON_DELETE_ONE_SUCCESS'
    };

    return this.bringozToastService.success(message, {name: vehicleStatusChangeReason.name})
  }

  deleteVehicleStatusChangeReasonError() {
    const message = {
      body: 'X_VEHICLE_STATUS_CHANGE_REASON_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getOneVehicleStatusChangeReasonError() {
    const message = {
      body: 'VEHICLE_STATUS_CHANGE_REASON_GET_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createAbsenceReasonSuccess() {
    const message = {
      body: 'CREATE_ABSENCE_REASON_SUCCESS'
    };

    return this.bringozToastService.success(message)
  }

  createAbsenceReasonError() {
    const message = {
      body: 'CREATE_ABSENCE_REASON_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };

    return this.bringozToastService.error(message)
  }

  updateAbsenceReasonSuccess() {
    const message = {
      body: 'UPDATE_ABSENCE_REASON_SUCCESS'
    };

    return this.bringozToastService.success(message)
  }

  updateAbsenceReasonError() {
    const message = {
      body: 'UPDATE_ABSENCE_REASON_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };

    return this.bringozToastService.error(message)
  }


  deleteAbsenceReasonSuccess() {
    const message = {
      body: 'DELETE_ABSENCE_REASON_SUCCESS'
    };

    return this.bringozToastService.success(message)
  }

  deleteAbsenceReasonError() {
    const message = {
      body: 'DELETE_ABSENCE_REASON_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };

    return this.bringozToastService.error(message)
  }

  //////////////////// BREAK TYPES ////////////////////

  createBreakTypeSuccess() {
    const message = {
      body: 'CREATE_BREAK_TYPE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createBreakTypeError(error?) {
    const message = {
      body: 'CREATE_BREAK_TYPE_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateBreakTypeSuccess() {
    const message = {
      body: 'UPDATE_BREAK_TYPE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateBreakTypeError(error?) {
    const message = {
      body: 'UPDATE_BREAK_TYPE_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteBreakTypeSuccess() {
    const message = {
      body: 'DELETE_BREAK_TYPE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteBreakTypeError() {
    const message = {
      body: 'DELETE_BREAK_TYPE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  shipperPortalConfigurationEditSuccess() {
    const message = {
      body: 'SHIPPER_PORTAL_CONFIGURATION_EDIT_SUCCESS'
    };

    return this.bringozToastService.success(message)
  }

  shipperPortalConfigurationEditError() {
    const message = {
      body: 'SHIPPER_PORTAL_CONFIGURATION_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };

    return this.bringozToastService.error(message)
  }


  createCustomFieldSuccess() {
    const message = {
      body: 'CUSTOM_FIELD_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createCustomFieldError() {
    const message = {
      body: 'CUSTOM_FIELD_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateCustomFieldSuccess() {
    const message = {
      body: 'CUSTOM_FIELD_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateCustomFieldError() {
    const message = {
      body: 'CUSTOM_FIELD_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteCustomFieldSuccess() {
    const message = {
      body: 'CUSTOM_FIELD_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteCustomFieldError() {
    const message = {
      body: 'CUSTOM_FIELD_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createEmailReportConfigurationSuccess() {
    const message = {
      body: 'EMAIL_REPORT_CONFIGURATION_CREATE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createEmailReportConfigurationError() {
    const message = {
      body: 'EMAIL_REPORT_CONFIGURATION_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateEmailReportConfigurationSuccess() {
    const message = {
      body: 'EMAIL_REPORT_CONFIGURATION_UPDATE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  updateEmailReportConfigurationError() {
    const message = {
      body: 'EMAIL_REPORT_CONFIGURATION_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // getAllRolesGroups(){
  //   const message = {
  //     body: 'GET_ALL_ROLES_GROUPS_ERROR',
  //     details: 'SOMETHING_WENT_WRONG'
  //   };
  //   return this.bringozToastService.error(message)
  // }
  //
  // createRolesGroupError(){
  //   const message = {
  //     body: 'CREATE_ROLES_GROUPS_ERROR',
  //     details: 'SOMETHING_WENT_WRONG'
  //   };
  //   return this.bringozToastService.error(message)
  // }
  //
  // createRolesGroupSuccess(){
  //   const message = {
  //     body: 'CREATE_ROLES_GROUPS_SUCCESS',
  //   };
  //   return this.bringozToastService.success(message)
  // }
  //
  // deleteRolesGroupError(){
  //   const message = {
  //     body: 'DELETE_ROLES_GROUPS_ERROR',
  //     details: 'SOMETHING_WENT_WRONG'
  //   };
  //   return this.bringozToastService.error(message)
  // }
  //
  // deleteRolesGroupSuccess(){
  //   const message = {
  //     body: 'DELETE_ROLES_GROUPS_SUCCESS',
  //   };
  //   return this.bringozToastService.success(message)
  // }
  //
  // editRolesGroupError(){
  //   const message = {
  //     body: 'EDIT_ROLES_GROUPS_ERROR',
  //     details: 'SOMETHING_WENT_WRONG'
  //   };
  //   return this.bringozToastService.error(message)
  // }
  //
  // editRolesGroupSuccess(){
  //   const message = {
  //     body: 'EDIT_ROLES_GROUPS_SUCCESS',
  //   };
  //   return this.bringozToastService.success(message)
  // }
  //
  // addMembersToGroupError(){
  //   const message = {
  //     body: 'ADD_MEMBERS_TO_GROUP_ERROR',
  //     details: 'SOMETHING_WENT_WRONG'
  //   };
  //   return this.bringozToastService.error(message)
  // }
  //
  // addMembersToGroupSuccess(){
  //   const message = {
  //     body: 'ADD_MEMBERS_TO_GROUP_SUCCESS',
  //   };
  //   return this.bringozToastService.success(message)
  // }
}

angular
  .module('bringoz.admin.site-preferences')
  .service('settingsAlertsService', SettingsAlertsService);
